import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';

export const convertContent = (content: string) => {
  if (content) {
    const contentBlock = htmlToDraft(content);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      return EditorState.createWithContent(contentState);
    }
  }
  return EditorState.createEmpty();
};

/**
 * @desc convert array to a shorter paragraph wiht "+" and total remaining to be displayed
 * @param min - initial total string to be display.
 * @param lists - array of strings.
 * @return string - formatted set of strings. e.g from ["foo", "bar", "baz"] to "foo, bar +1"
 */
export const arrayToParagraphShortener = ({ min = 2, lists = [] }: { min?: number; lists: string[] }) => {
  return lists.length
    ? lists.length > min
      ? lists.slice(0, min).join(', ') + ` +${lists.length - min}`
      : lists.join(',')
    : '-';
};
